import { SVG } from '../svg';
import { IconProps } from '../types';

export function ErrorCircleIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="m15 9-6 6" />
      <path d="m9 9 6 6" />
    </SVG>
  );
}
